module.exports = __webpack_public_path__ + "img/B.ba6cf18e.png";